import type { ComponentProps, ReactNode } from "react";
import { useCallback, useMemo } from "react";

import { Select } from "@skilitics/designer-ui-components";

import { type ElementState, type ElementStateOption } from "./types";

type Props = Partial<Omit<ComponentProps<typeof Select>, "value" | "onChange">> & {
  value: ElementState;
  onChange: (value: ElementState) => void;
  allowedOptions: ElementStateOption[];
};

export const ElementStatePicker = ({ value, onChange, allowedOptions, ...selectProps }: Props) => {
  const handleChange: ComponentProps<typeof Select>["onChange"] = (e) => {
    onChange(e.target.value as `${ElementState}`);
  };

  const plainLabelsByValue = useMemo(
    () => new Map<string, ReactNode>(allowedOptions.map((opt) => [opt.value, opt.plainLabel ?? opt.label])),
    [allowedOptions],
  );

  const renderValue = useCallback(
    (selected: unknown) => plainLabelsByValue.get(selected as string) ?? String(selected),
    [plainLabelsByValue],
  );

  return (
    <Select
      label="Element State"
      shrinkLabel
      value={value}
      onChange={handleChange}
      options={allowedOptions}
      renderValue={renderValue}
      {...selectProps}
    />
  );
};
